import Vue from "vue";
// @ts-ignore
import Vuetify from "vuetify/lib";
import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "@fortawesome/fontawesome-free/css/regular.min.css";
import "@fortawesome/fontawesome-free/css/solid.min.css";
import "@fortawesome/fontawesome-free/css/brands.min.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(far, fas, fab);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "fa",
    values: {
      instagram: "fab fa-instagram",
      linkedin: "fab fa-linkedin"
    }
  },
  rtl: false,
  theme: {
    dark: false,
    themes: {
      dark: {
        primary: "#e5292d",
        accent: "#ed9c26",
        secondary: "#7b1e1a",
        success: "#e5292d",
        info: "#e5292d",
        warning: "#ed9c26",
        error: "#7b1e1a"
      },
      light: {
        primary: "#e5292d",
        accent: "#ed9c26",
        secondary: "#7b1e1a",
        success: "#e5292d",
        info: "#e5292d",
        warning: "#ed9c26",
        error: "#7b1e1a"
      }
    }
  }
});
